var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-popup',{staticClass:"popup-select-736",attrs:{"title":"공정분류표(직영)","active":_vm.showPopup},on:{"update:active":function($event){_vm.showPopup=$event}}},[_c('keep-alive',[(_vm.hasLoadedOnce)?_c('page736',{ref:"page736",attrs:{"mode":"popup"},on:{"close":function($event){_vm.showPopup = false},"select":_vm.onSelect}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }